/// <reference path="ProdottiEsperienzePunteggiGrid.ts"/>

namespace Gamification.Gamification {

    @Serenity.Decorators.registerClass("Gamification.Gamification.ProdottiEsperienzePunteggiDetailGrid")
    export class ProdottiEsperienzePunteggiDetailGrid extends Gamification.ProdottiEsperienzePunteggiGrid {
        constructor(container: JQuery) {
            super(container);
        }

        protected usePager() {
            return false;
        }

        protected getButtons(): Serenity.ToolButton[] {
            var buttons = super.getButtons();

            // Remove Button
            buttons.splice(Q.indexOf(buttons, x => x.cssClass == "column-picker-button"), 1);

            if (Q.Authorization.hasPermission("Role:SuperAdmin")) {
                // Remove Button
                buttons.splice(Q.indexOf(buttons, x => x.cssClass == "add-button"), 1);
            }

            //
            return buttons;
        }

        protected getGridCanLoad() {
            return super.getGridCanLoad() && !!this.IdProdottoEsperienza;
        }

        private _IdProdottoEsperienza: number;

        get IdProdottoEsperienza() {
            return this._IdProdottoEsperienza;
        }

        set IdProdottoEsperienza(value: number) {
            if (this._IdProdottoEsperienza !== value) {
                this._IdProdottoEsperienza = value;
                this.setEquality('IdProdottoEsperienza', value);
                this.refresh();
            }
        }
    }
}